module.exports = __webpack_public_path__ + "img/ring_r_l_0_0@3x.7f6e078f.png";